import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClientXml from "../../utils/HttpClientXml";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import Swal from "sweetalert2";
import { Form, Link, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackPageBtn from "../BackButton/BackPageBtn";

const ManageUser = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const imgURL = "https://api.deshvidesh.ca";

  const [allData, setAllData] = useState();
  const [editId, setEditId] = useState("");
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);

  const initValue = {
    serviceName: "",
    documentation: selectedTypes,
  };
  const [formValue, setFormValue] = useState(initValue);

  const fetchDocumentTypes = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data);
      if (response && response?.status) {
        setDocumentTypes(response.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  console.log("jhsgdfjhakd", editId);

  const [isEdit, setIsEdit] = useState(true);
  const [editData, setEditData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
  };

  // submit
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // console.log("alldasdasdd", formValue);
  //   // return
  //   const { title, description } = formValue;
  //   const isValid = title.trim() !== "" && description.trim() !== "";

  //   if (isValid) {
  //     if (formValue?.image1 === "" || formValue?.image2 === "") {
  //       return toast.error("Please Upload Images");
  //     } else {
  //       const res = await HomeServices.addBlog(formValue);
  //       // console.log("resCat", res)
  //       if (res && res?.status) {
  //         toast.success("Blog Added Successfully");
  //         fetchData();

  //         // navigate('/manage-category');
  //         setIsLoading(false);
  //         console.log("formValue21456", formValue);
  //       } else {
  //         toast.error(res?.message || "Something Wrong");
  //         setIsLoading(false);
  //       }
  //     }
  //   } else {
  //     toast.error("Please Fill All The Inputs, Including the Image.");
  //   }
  // };

  const viewAssignedServices = (e, item) => {
    e.preventDefault();
    navigate("/assigned-services", { state: { user: item } });
  };

  const viewPayments = (e, item) => {
    e.preventDefault();
    navigate("/manage-payments", { state: { user: item } });
  };

  // const columns = [
  //   { name: "SL No.", selector: "sln", sortable: true },
  //   { name: "Customer#", selector: "customerNo", wrap: true },
  //   { name: "Name", selector: "name", wrap: true },
  //   { name: "Email", selector: "email", wrap: true },
  //   { name: "Service", selector: "viewServices", wrap: true },
  //   { name: "Payments", selector: "payments", wrap: true },
  //   { name: "Staff", selector: "staff", wrap: true },
  // ];

  const columns = [
    { name: "SL No.", selector: (row, index) => index + 1, sortable: true },
    {
      name: "Customer#",
      selector: (row) => row?.userData?.customerNo,
      wrap: true,
    },
    { name: "Name", selector: (row) => row?.userData?.name, wrap: true },
    {
      name: "Email",
      selector: (row) => row?.userData?.email,
      wrap: true,
      width: "250px",
    },
    {
      name: "Service",
      selector: (row) => (
        <div>
          <button
            style={{
              backgroundColor: "#549c40",
              fontSize: "14px",
              padding: "5px",
              color: "white",
              borderRadius: "5px",
              border: "none",
            }}
            onClick={(e) => viewAssignedServices(e, row)}
          >
            View/Assign{` (${row?.userData?.AssignServices?.length})`}
          </button>
        </div>
      ),
      wrap: true,
    },
    {
      name: "Calnder Notes",
      selector: (row) => (
        <div>
          <button
            style={{
              padding: "3px 5px",
              borderRadius: "5px",
              backgroundColor: "#9c9206",
              color: "white",
              height: "40px",
              fontWeight: "400",
              border: "none",
            }}
            onClick={() => {
              navigate("/calendar-notes", {
                state: {
                  user: row,
                },
              });
            }}
          >
            Add / View Reminder
          </button>
        </div>
      ),
      wrap: true,
    },
    // {
    //   name: "Payments",
    //   selector: (row) => (
    //     <div>
    //       <button
    //         onClick={(e) => viewPayments(e, row)}
    //         style={{
    //           backgroundColor: "#549c40",
    //           fontSize: "14px",
    //           padding: "5px",
    //           color: "white",
    //           borderRadius: "5px",
    //           border: "none",
    //         }}
    //       >
    //         View/Send Link
    //       </button>
    //     </div>
    //   ),
    //   wrap: true,
    // },
    {
      name: "Application Form",
      selector: (row) => (
        <div>
          {row?.userData?.PrimaryApplicantData?.isFinallySubmittedForm && (
            <div>
              <button
                style={{
                  padding: "3px 5px",
                  borderRadius: "5px",
                  backgroundColor: "#871903",
                  color: "white",
                  height: "40px",
                  fontWeight: "400",
                }}
                onClick={() => {
                  navigate("/immigration-form-view", {
                    state: {
                      fullFormData: row?.userData?.PrimaryApplicantData,
                    },
                  });
                }}
              >
                View Application
              </button>
            </div>
          )}
        </div>
      ),
      wrap: true,
    },
    // {
    //   name: "Staff",
    //   selector: (row) => (
    //     <div>
    //       <button
    //         style={{
    //           backgroundColor: "#409c91",
    //           fontSize: "14px",
    //           padding: "5px",
    //           color: "white",
    //           borderRadius: "5px",
    //           border: "none",
    //         }}
    //       >
    //         Assign Staff
    //       </button>
    //     </div>
    //   ),
    //   wrap: true,
    // },
  ];

  const [allDataWithoutFilter, setAllDataWithoutFilter] = useState([]);
  // const fetchData = async () => {
  //   try {
  //     // Call your API function
  //     const response = await HomeServices.getAllUsers();
  //     console.log("SER99", response);
  //     if (response && response?.status) {
  //       let arr = response?.data?.reverse()?.map((ele, index) => {
  //         return {
  //           sln: index + 1,
  //           customerNo: ele?.customerNo,
  //           name: ele?.name,
  //           email: ele?.email,
  //           viewServices: (
  //             <>
  //               <div>
  //                 <button
  //                   type="button"
  //                   className="btn btn-success btn-sm"
  //                   onClick={(e) => viewAssignedServices(e, ele)}
  //                 >
  //                   View/Assign ({ele?.AssignServices?.length})
  //                 </button>
  //               </div>
  //             </>
  //           ),
  //           payments: (
  //             <>
  //               <div>
  //                 <button
  //                   type="button"
  //                   className="btn btn-success btn-sm"
  //                   onClick={(e) => viewPayments(e, ele)}
  //                 >
  //                   View/Send Link
  //                 </button>
  //               </div>
  //             </>
  //           ),
  //           staff: (
  //             <>
  //               <div>
  //                 <button
  //                   type="button"
  //                   className="btn btn-info btn-sm"
  //                   // onClick={(e) => viewAssignedServices(e, ele)}
  //                 >
  //                   Assign Staff
  //                 </button>
  //               </div>
  //             </>
  //           ),
  //         };
  //       });
  //       setAllData(arr);
  //       setAllDataWithoutFilter(arr);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching warehouse data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchDocumentTypes();
  //   fetchData();
  // }, []);

  const fetchAssignedUsers = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAssignedUsers();
      console.log("users", response);
      if (response && response?.status) {
        setAssignedUsers(response?.data?.reverse());
        console.log("Amit Assigned Users", response);
      }
    } catch (error) {
      console.error("Error fetching Assigned Users:", error);
    }
  };

  useEffect(() => {
    fetchAssignedUsers();
  }, []);

  // const handleDelete = async (id) => {
  //   console.log("deleteblogid", id);
  //   Swal.fire({
  //     title: "Are you sure?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     console.log("result", result);
  //     if (result?.isConfirmed) {
  //       HomeServices.deleteService(id)
  //         .then((res) => {
  //           if (res && res.status) {
  //             toast.success("Deleted Successfully");
  //             fetchData();
  //           } else {
  //             toast.error(res?.message);
  //           }
  //         })
  //         .catch((err) => {
  //           console.error("Error deleting document:", err);
  //         });
  //     } else {
  //       console.log("Deletion canceled");
  //     }
  //   });
  // };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedTypes((prev) =>
      checked ? [...prev, value] : prev.filter((type) => type !== value),
    );
  };

  useEffect(() => {
    setFormValue({ ...formValue, documentation: selectedTypes });
  }, [selectedTypes]);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const filtered = allDataWithoutFilter.filter(
      (item) =>
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.email.toLowerCase().includes(searchText.toLowerCase()),
    );

    setAllData(filtered);
  }, [searchText]);

  const allData1 = [
    {
      sln: "1",
      customerNo: "7896521",
      name: "Amit Roy",
      email: "abc@gmail.com",
      // viewServices: "hello",
    },
    {
      sln: "1",
      customerNo: "7896521",
      name: "Amit Roy",
      email: "abc@gmail.com",
      // viewServices: "hello",
    },
    {
      sln: "1",
      customerNo: "7896521",
      name: "Amit Roy",
      email: "abc@gmail.com",
      // viewServices: "hello",
    },
  ];
  return (
    <>
      <CustomLoader loading={isLoading} />

      {/* {allData?.length > 0 && ( */}
      {assignedUsers?.length == 0 && (
        <div className="d-flex justify-content-end">
          <div className="form-header">
            <div
              className="piechartsBox_area"
              style={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              No Assigned User Found
            </div>
          </div>
        </div>
      )}
      {assignedUsers?.length > 0 && (
        <>
          <div className="d-flex justify-content-end">
            <div className="form-header">
              <section className="piechartsBox_area">
                <div>
                  {/* <BackPageBtn backLink="/view-user-appointment" /> */}
                  <div className="dateListDiv">
                    <h1
                      style={{
                        color: "#ff9c00",
                        fontSize: "25px",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      View All Assigned Users
                    </h1>

                    <div className="tabRngeDivmain">
                      <div className="strtdivmain">
                        {/* <p className="strttxt">User Email</p> */}
                        <input
                          type="email"
                          name="filterEmail"
                          placeholder="Enter user name/email"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </div>
                      {/* <span>-</span> */}
                      {/* <div className="strtdivmain">
                                      <p className="strttxt">End Date</p>
                                      <input
                                        type="date"
                                        name="endDate"
                                        value={endDate}
                                        onChange={handleEndDateChange}
                                      />
                                    </div> */}
                      {/* <button
                          onClick={filterDataByDateRange}
                          className="Search_icon btn btn-primary"
                          type="button"
                        >
                          Search
                        </button> */}
                    </div>
                  </div>
                </div>

                <hr />
                {/* <DataTable columns={columns} data={allData} pagination /> */}
                <DataTable columns={columns} data={assignedUsers} pagination />
              </section>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ManageUser;
